import { atempl } from '@api/v0/fetch/.endpoints';
import { PostRequest } from '../post/request';

class NewsRequest extends PostRequest{
	constructor() {
		super();
	}

	init(){
		this.id = 'article';
		this.formId = '#archive-article-filter'
		this.setPayload();
		this.setUrlHandler();
		this.createFilter();
		this.eventListeners();
	}

	setPayload() {
		atempl.models.setPayload(this.id, {
			'model': 'Article',
			'cache': false,
			'fields': ['id', 'title', 'permalink', 'byline', 'strapline', 'excerpt', 'thumbnail', 'link'],
			'args': {
				'lang': atnlbs_default.lang,
				'posts_per_page': 12,
			}
		}, {
			'X-WP-Nonce': atnlbs_default.nonce
		});
	}
}

new NewsRequest();
